'use client';

import useSWR from 'swr';
import { subscriptionsApi } from '@/lib/api';
import type { BillingInvoiceDto, PlanDto, SubscriptionDto } from '@/lib/api';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useSubscription() {
  const authedFetch = useAuthedFetcher();
  return useSWR<SubscriptionDto>(
    ['subscription-me'],
    () => authedFetch((token) => subscriptionsApi.me(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}

export function usePlans(enabled = true) {
  const authedFetch = useAuthedFetcher();
  return useSWR<PlanDto[]>(
    enabled ? ['subscription-plans'] : null,
    () => authedFetch((token) => subscriptionsApi.plans(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}

export function useBillingInvoices(limit = 20) {
  const authedFetch = useAuthedFetcher();
  return useSWR<BillingInvoiceDto[]>(
    ['billing-invoices', limit],
    () => authedFetch((token) => subscriptionsApi.invoices(token, { limit })),
    LONG_LIVED_SWR_OPTIONS,
  );
}
